import type { User } from '@gcv/shared';

export enum UserType {
  Bank = 'bank',
  Dispensary = 'dispensary',
  GCV = 'gcv'
}

export interface UserWithType extends User {
  type: UserType;
}
